<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">营销</a></el-breadcrumb-item>
          <el-breadcrumb-item>优惠券包</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="couponPackage" label-width="160px" >
        <el-form-item label="优惠券名称">
          <el-col :span="11">
            <el-input v-model="couponPackage.name" ></el-input>
          </el-col>
        </el-form-item>   
        <el-form-item label="优惠券包类型">
          <el-col :span="11">
            <el-radio-group v-model="couponPackage.type">
              <el-radio :label="0">线下赠送</el-radio>
              <el-radio :label="1">线上购买</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>         
        <el-form-item label="售价" v-if="couponPackage.type==1">
          <el-col :span="11" >
            <el-input v-model="couponPackage.price" >
              <el-button slot="append" >元</el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="Icon图标">
          <el-col :span="12">
            <el-upload
              class="icon-uploader"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              :on-success="handleIconSuccess"
              :before-upload="beforeIconUpload">
              <img v-if="couponPackage.icon" :src="couponPackage.icon" class="icon">
              <i v-else class="el-icon-plus icon-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">请上传1:1大小的图标(如100px*100px)</div>
            </el-upload>
          </el-col>
        </el-form-item>  
        <el-form-item label="代金券">
          <el-col :span="11" :inline="true" >
             <el-select v-model="couponSelect"  placeholder="请选择">
              <el-option
                v-for="item in coupons"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button type="default" @click="addCoupn">添加</el-button>
          </el-col>
        </el-form-item>
        <el-table :data="items" style="width: 90%;margin-left:5%">
          <el-table-column  fixed  prop="Name"  label="代金券" > </el-table-column>
          <el-table-column  fixed  prop="Number"  label="数量" >
            <template slot-scope="scope">
              <el-input-number :min="0"  v-model="scope.row.Number" size="mini"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column  fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click.native.prevent="Delete(scope.row)" type="text" size="small">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>    
        <el-form-item label="分享描述">
          <el-col :span="11">
            <el-input type="textarea" v-model="couponPackage.shareDescription"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="描述">
          <editor @showEditor="updateDescription" :content="couponPackage.description"></editor>
        </el-form-item>
        <el-form-item >
          <el-col :span="11">
            <el-button type="primary" @click="Save">确 定</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import { Message } from 'element-ui'
  import editor from '@/components/wang-editor'
  export default {
    props:{
    },
    data (){
      return {
        couponPackage:{},
        uploadUrl: this.global.serverSrc+'/api/Common/UploadImage',
        headers:{
          Authorization : sessionStorage.getItem('token')
        },
        items:[],
        value: [],        
        coupons: [],
        couponSelect:''
      }
    },
    computed:{      
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/CouponPackage/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.coupons = resp.data.coupons
        that.couponPackage = resp.data.couponPackage
        that.items= resp.data.couponPackageItems
      })
      
    },
    methods:{     
      Save:function(){
        var that = this
        that.couponPackage.CouponPackageItems =JSON.stringify(that.items)
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/CouponPackage/Save',         
          data: that.couponPackage
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleIconSuccess(res, file){
        this.chainStore.Icon= res.fullUrl
        //this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeIconUpload(file){
        const isLt2M = file.size / 1024 / 1024 < 2;        
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
      },
      updateDescription(data){
        this.coupon.description=data
      },
      addCoupn:function(){        
        var item= this.items.find(item=>item.CouponId==this.couponSelect)
        if(item)
          item.Number += 1
        else {
          var item={
            CouponId:this.couponSelect,
            Number:1,
            Name: this.coupons.find(item=>item.id=this.couponSelect).name
          }
          this.items.push(item)
        }
        
      },
      Delete:function(row){
        debugger
        this.items.pop(row)
      }
    },
    components:{    
      editor
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
  .icon-uploader
    .el-upload
      border 1px dashed #d9d9d9
      border-radius 6px
      cursor pointer
      position relative
      overflow hidden
      .el-upload
      &:hover
        border-color #409EFF
      img
        width 100px
        height 100px
  .icon-uploader-icon
    font-size 28px
    color #8c939d
    width 100px
    height 100px
    line-height 100px
    text-align center  
</style>